/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridColumnPinOptions } from './igr-grid-column-pin-options';
import { GridColumnPinOptions } from './GridColumnPinOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnPinOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnPinOptionsModule() {
    }
    IgrGridColumnPinOptionsModule.register = function () {
        TypeRegistrar.registerCons('IgrGridColumnPinOptions', IgrGridColumnPinOptions);
        TypeRegistrar.registerCons('IgrGridColumnPinOptions', IgrGridColumnPinOptions);
        TypeRegistrar.register('GridColumnPinOptions', GridColumnPinOptions.$type);
    };
    return IgrGridColumnPinOptionsModule;
}());
export { IgrGridColumnPinOptionsModule };
//# sourceMappingURL=igr-grid-column-pin-options-module.js.map
